import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import ModalsWrapper from "../components/Wrappers/ModalsWrapper";
import FeedbackSubmited from "../components/Modals/FeedbackSubmited";
import { useDispatch, useSelector } from "react-redux";
import { setDownloadImageModal, setIsOpenShareFeedbackModal, setIsOpenShareFeedbackSuccessModal, setIsOpenTermsAndConditionsModal, setIsOpenViewDetailsModal } from "../redux/imageModalSlice";
import ShareImageFeedback from "../components/Modals/ShareImageFeedback";
import ViewImageDetails from "../components/Modals/ViewImageDetails";
import DoMoreWithFonts from "../components/Modals/DoMoreWithFonts";
import TermsAndConditions from "../components/Modals/TermsAndConditions";
import ImageRating from "../components/Modals/ImageRating";

const MainLayout = () => {
  const dispatch = useDispatch();
  const { singleImageData,
    isOpenShareFeedbackModal,
    isShareFeedbackSuccess,
    isOpenShareFeedbackSuccessModal,
    isOpenViewDetailsModal,
    isOpenDownloadImageModal,
    isOpenTermsAndConditionsModal
  } = useSelector((state) => state.imageModalData || {});


  return (
    <div className="h-screen flex flex-col">
      <Navbar />
      <Outlet />

      <ModalsWrapper open={isOpenViewDetailsModal} onClose={() => dispatch(setIsOpenViewDetailsModal(false))}  >
        <ViewImageDetails
          imageData={singleImageData}
          onCloseViewDetail={() => dispatch(setIsOpenViewDetailsModal(false))}
          openShareFeedback={() => dispatch(setIsOpenShareFeedbackModal(true))}
        />
      </ModalsWrapper>

      {/* <ModalsWrapper open={isOpenShareFeedbackModal} onClose={() => dispatch(setIsOpenShareFeedbackModal(false))} >
        <ShareImageFeedback
          imageData={singleImageData}
        />
        <ImageRating imageData={singleImageData}/>
      </ModalsWrapper> */}

      <ModalsWrapper open={isOpenShareFeedbackSuccessModal} onClose={() => dispatch(setIsOpenShareFeedbackSuccessModal(false))} >
        <FeedbackSubmited success={isShareFeedbackSuccess} onClose={() => dispatch(setIsOpenShareFeedbackSuccessModal(false))} />
      </ModalsWrapper>

      <ModalsWrapper open={isOpenDownloadImageModal} onClose={() => dispatch(setDownloadImageModal(false))}  >
        <DoMoreWithFonts imageData={singleImageData} onClose={() => dispatch(setDownloadImageModal(false))} />
      </ModalsWrapper>

      <ModalsWrapper open={isOpenTermsAndConditionsModal} onClose={() => dispatch(setIsOpenTermsAndConditionsModal(false))} >
        <TermsAndConditions />
      </ModalsWrapper>
    </div>
  );
};

export default MainLayout;